const appStoreUrl = 'https://itunes.apple.com/us/app/tramo-transaction-monitor/id1458662183?ls=1&mt=12'

export {
  appStoreUrl
}
